"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var react_1 = __importStar(require("react"));
var bundle_1 = require("../store/bundle");
var scrolling_1 = require("../utils/scrolling");
var PatternDisplay = function (_a) {
    var _b;
    var size = _a.size, quantity = _a.quantity, variant = _a.variant, imageHeight = _a.imageHeight;
    var totalPrice = Number(variant.price) * quantity;
    var priceDisplay = "$".concat((0, currency_js_1.default)(totalPrice));
    // only show the price if it's non-zero for cleanliness
    var showPrice = totalPrice !== 0;
    return (react_1.default.createElement("div", { className: 'flex-container align-justify' },
        react_1.default.createElement("div", { className: 'flex-container space-x-4' },
            ((_b = variant.featuredImage) === null || _b === void 0 ? void 0 : _b.src) && (react_1.default.createElement("div", { style: { aspectRatio: '1/1', height: imageHeight, opacity: 0.8 } },
                react_1.default.createElement("img", { src: variant.featuredImage.src, alt: variant.featuredImage.alt }))),
            react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify padding-vertical-1', style: { lineHeight: 1 } },
                react_1.default.createElement("div", { className: 'text-sm' },
                    quantity,
                    " x ",
                    variant.title),
                react_1.default.createElement("div", { className: 'text-gray text-sm' }, size))),
        showPrice && react_1.default.createElement("div", { className: 'text-sm' }, priceDisplay)));
};
var AddonDisplay = function (_a) {
    var addon = _a.addon, product = _a.product, quantity = _a.quantity;
    var totalPrice = Number(addon.price) * (quantity !== undefined ? quantity : 1);
    var priceDisplay = "$".concat((0, currency_js_1.default)(totalPrice));
    var totalCompareAtPrice = Number(addon.compareAtPrice) * (quantity !== undefined ? quantity : 1);
    var compareAtPriceDisplay = "$".concat((0, currency_js_1.default)(totalCompareAtPrice));
    return (react_1.default.createElement("div", { className: 'flex-container align-justify' },
        react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify' },
            react_1.default.createElement("div", { className: 'text-sm' },
                quantity,
                " x ",
                product.title),
            addon.option1.toLowerCase() !== 'default title' && react_1.default.createElement("div", { className: 'text-gray text-sm' }, addon.option1)),
        react_1.default.createElement("div", { className: 'text-sm' },
            react_1.default.createElement("span", { className: 'strike text-gray' }, compareAtPriceDisplay),
            "\u00A0\u00A0",
            priceDisplay)));
};
var AutoAddonDisplay = function (_a) {
    var addon = _a.addon, product = _a.product, quantity = _a.quantity;
    return (react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify' },
        react_1.default.createElement("div", { className: 'text-sm' },
            quantity,
            " x ",
            product.title),
        addon.option1.toLowerCase() !== 'default title' && react_1.default.createElement("div", { className: 'text-gray text-sm' }, addon.option1)));
};
var ProductGroup = function (_a) {
    var children = _a.children, title = _a.title, price = _a.price;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'flex-container align-justify' },
            react_1.default.createElement("div", { className: 'text-xl', style: { fontWeight: 600 } }, title),
            react_1.default.createElement("div", { className: 'text-soft-purple text-sm' }, price)),
        react_1.default.createElement("div", { className: 'h-2' }),
        react_1.default.createElement("div", { className: 'space-y-2 padding-left-6' }, children)));
};
var Review = function (_a) {
    var e_1, _b;
    var navBar = _a.navBar;
    var useBundleStore = (0, bundle_1.getBundleStore)().useBundleStore;
    var selectedFreebieAddons = useBundleStore(function (state) { return state.selectedFreebieAddons; });
    var selectedDiscountAddons = useBundleStore(function (state) { return state.selectedDiscountAddons; });
    var selectedAutoAddons = useBundleStore(function (state) { return state.selectedAutoAddons; });
    var selectedPatterns = useBundleStore(function (state) { return state.selectedPatterns; });
    var selectedMainVariant = useBundleStore(function (state) { return state.selectedMainVariant; });
    var calculateBundleSubtotal = useBundleStore(function (state) { return state.calculateBundleSubtotal; });
    var buildBundle = useBundleStore(function (state) { return state.buildBundle; });
    var isComplete = useBundleStore(function (state) { return state.isComplete; });
    var _c = __read((0, react_1.useState)(false), 2), isAddingToCart = _c[0], setIsAddingToCart = _c[1];
    // Instantly scroll to top. This is necessary because we share the page's scrollbar between all of the steps
    // and we want the user to start at the top of each step.
    var hasPerformedInitialScrollToTop = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!hasPerformedInitialScrollToTop.current) {
            (0, scrolling_1.performInstantScroll)(window, { top: 0 });
            hasPerformedInitialScrollToTop.current = true;
        }
    });
    var hasEmittedDataLayerEvent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!hasEmittedDataLayerEvent.current) {
            // TODO: report pattern quantity here since we couldn't report it yet when the user arrived at the discounts step?
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__confirm', selectedFrequency: bundle_1.SHIP_FREQ_WEEKS });
            hasEmittedDataLayerEvent.current = true;
        }
    });
    // map sizes to display text
    var displaySizeMap = {
        diaper_n: 'Diaper Size N',
        diaper_1: 'Diaper Size 1',
        diaper_2: 'Diaper Size 2',
        diaper_3: 'Diaper Size 3',
        diaper_4: 'Diaper Size 4',
        diaper_5: 'Diaper Size 5',
        diaper_6: 'Diaper Size 6',
        training_12_24: 'Training Pant Size 12-24M',
        training_2t_3t: 'Training Pant Size 2T-3T',
        training_3t_4t: 'Training Pant Size 3T-4T',
        training_4t_5t: 'Training Pant Size 4T-5T',
        mixed_12_24: 'Training Pant Size 12-24M',
        mixed_2t_3t: 'Training Pant Size 2T-3T',
        mixed_3t_4t: 'Training Pant Size 3T-4T',
        mixed_4t_5t: 'Training Pant Size 4T-5T',
    };
    var autoAddonDisplays = [];
    try {
        for (var _d = __values(Object.values(selectedAutoAddons)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var addon = _e.value;
            // we only have Wipes auto addons, so just hardcode this for now
            autoAddonDisplays.push({ variant: addon.variant, quantity: addon.quantity, product: { title: 'Wipes' } });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    // handle adding to cart and don't actually go next
    var beforeGoNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var bundle, REDIRECT_TO_CHECKOUT, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsAddingToCart(true);
                    bundle = buildBundle();
                    if (!bundle)
                        throw new Error('Invalid bundle');
                    (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({ event: 'diaperBundle__addToCart', bundleVariantId: selectedMainVariant === null || selectedMainVariant === void 0 ? void 0 : selectedMainVariant.id, bundleVariantName: selectedMainVariant === null || selectedMainVariant === void 0 ? void 0 : selectedMainVariant.name });
                    REDIRECT_TO_CHECKOUT = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, window.cartApp.add(bundle, { redirectToCheckout: REDIRECT_TO_CHECKOUT })];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    setIsAddingToCart(false);
                    throw error_1;
                case 4:
                    setIsAddingToCart(false);
                    // don't actually go next; there is no next step
                    return [2 /*return*/, false];
            }
        });
    }); };
    var backButtonEnabled = true;
    var nextButtonEnabled = isComplete();
    // we may eventually turn this into an optimize or CMS setting
    var SHOW_SUBTOTAL = false;
    var subtotalDisplay = SHOW_SUBTOTAL ? "$".concat((0, currency_js_1.default)(calculateBundleSubtotal())) : undefined;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", { className: 'padding-horizontal-6 space-y-2' },
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-2xl', style: { fontWeight: 600 } }, "Review Your Bundle")),
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-almost-black' },
                    "Your Bundle will ship every ",
                    bundle_1.SHIP_FREQ_WEEKS,
                    " weeks. Cancel online anytime."))),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", { className: 'margin-horizontal-6 border-very-light-pink', style: { borderTopWidth: 1, borderTopStyle: 'solid' } }),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", { className: 'padding-horizontal-6' },
            react_1.default.createElement("div", { className: 'border-very-light-pink rounded-lg padding-vertical-6 padding-horizontal-6 space-y-4', style: { borderWidth: '1px', borderStyle: 'solid' } },
                react_1.default.createElement(ProductGroup, { title: 'Bundle', price: "$".concat(selectedMainVariant === null || selectedMainVariant === void 0 ? void 0 : selectedMainVariant.price) },
                    selectedPatterns.map(function (pattern) { return (react_1.default.createElement(PatternDisplay, { key: pattern.variant.id, variant: pattern.variant, size: displaySizeMap[pattern.size], quantity: pattern.quantity, imageHeight: '2.7rem' })); }),
                    autoAddonDisplays.map(function (display) { return (react_1.default.createElement(AutoAddonDisplay, { key: display.variant.id, addon: display.variant, product: display.product, quantity: display.quantity })); })),
                selectedFreebieAddons.length >= 1 && (react_1.default.createElement(ProductGroup, { title: 'Freebies' }, selectedFreebieAddons.map(function (addon) { return (react_1.default.createElement(AddonDisplay, { key: addon.variant.id, addon: addon.variant, product: addon.product, quantity: addon.quantity })); }))),
                selectedDiscountAddons.length >= 1 && (react_1.default.createElement(ProductGroup, { title: 'Extras' }, selectedDiscountAddons.map(function (addon) { return (react_1.default.createElement(AddonDisplay, { key: addon.variant.id, addon: addon.variant, product: addon.product, quantity: addon.quantity })); })))),
            subtotalDisplay && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'h-4' }),
                react_1.default.createElement("div", { className: 'padding-horizontal-6 flex-container align-justify align-middle' },
                    react_1.default.createElement("div", { className: 'flex-container flex-dir-column align-justify text-sm font-semibold' }, "Order Subtotal"),
                    react_1.default.createElement("div", { className: 'text-lg font-medium' }, subtotalDisplay))))),
        navBar({ backButtonEnabled: backButtonEnabled, nextButtonEnabled: nextButtonEnabled, beforeGoNext: beforeGoNext, nextText: 'Add to Cart', nextLoading: isAddingToCart })));
};
exports.default = Review;
